import React, { useState } from 'react';

import { useViewType, ViewType } from '@eika/hooks';

import SkipLink from '../../components/SkipLink/SkipLink';
import { Content } from '../../components/shared/Content';
import { useConfig } from '../../defaultConfig';
import { useRefreshAvtalegiro } from '../../fetchHooks/useAvtalegiro';
import type { PaymentAgreementId } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';
import { AvtalegiroActions } from '../AvtalegiroActions';
import AvtaleGiroDetails from './AvtaleGiroDetails';
import AvtaleGiroProposalList from './AvtaleGiroProposalList';
import AvtaleGiroList from './AvtalegiroList';

import './AvtaleGiro.scss';

export const ANALYTICS_CATEGORY_USABLE = 'create-new-avtalegiro';

const AvtaleGiro: React.FC = () => {
    const { featureToggles } = useConfig();
    const viewType = useViewType();
    const [showDetails, setShowDetails] = useState<boolean>(false);
    const [avtaleGiroId, setAvtaleGiroId] = useState<PaymentAgreementId | undefined>();

    const translated = useTranslation();

    const refreshAvtalegiro = useRefreshAvtalegiro();

    const handleSelectAvtaleGiro = (id: PaymentAgreementId) => {
        setShowDetails(true);
        setAvtaleGiroId(id);
    };
    const resetStates = () => {
        setAvtaleGiroId(undefined);
    };

    return (
        <div className="avtalegiro">
            {viewType === ViewType.desktop && (
                <SkipLink skipTo="#avtalegiro-action-button" linkText={translated.avtaleGiroAgreement.skipLink} />
            )}
            {!featureToggles.disableAvtaleGiroChanges && <AvtalegiroActions views={[ViewType.mobile, ViewType.pad]} />}
            <AvtaleGiroList selectAvtaleGiro={handleSelectAvtaleGiro} />
            {featureToggles.enableAvtaleGiroProposals && (
                <Content className="avtalegiro-proposal-list">
                    <AvtaleGiroProposalList />
                </Content>
            )}
            <>
                {avtaleGiroId && showDetails && (
                    <AvtaleGiroDetails
                        refreshAvtaleGiroList={() => refreshAvtalegiro()}
                        id={avtaleGiroId}
                        show={showDetails}
                        setShow={setShowDetails}
                        onClose={resetStates}
                    />
                )}
            </>
        </div>
    );
};

export default AvtaleGiro;
